import * as React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { FaSitemap } from 'react-icons/fa';
import { CodetableItemContentProps } from 'app/area/codetable/list/list-items/types';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { DisabledTag } from 'app/area/codetable/common/disabled-tag/disabled-tag';
import { renderLine } from 'app/area/shared/codetable/list-item/list-item-lines';
import { OptionColor } from 'ui/common/select/option/option-color';
import { OptionIcon } from 'ui/common/select/option/option-icon';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeActionType } from 'app/area/codetable/item/types';
import styles from './consequences-codetable-item-content.scss';

export const ConsequencesCodetableItemContent = ({ codeItem, isHierarchyMode, hierarchyMetadata,
  refetching, treeDepthLevel, breadcrumbs, translation, deletingCodeItem }: Partial<CodetableItemContentProps>) => {

  const contentClass = !isHierarchyMode ? styles.content : styles.hierarchyContent;
  const hasSequence = isDefinedIncludingZero(codeItem.sequence);

  return (
    <Link
      to={routeConstants.codetableAdministrationCodeFor(breadcrumbs, codeItem.id, CodeActionType.Edit)}
      className={`${styles.container} ${deletingCodeItem ? styles.disabled : ''}`}>
      {isHierarchyMode
        ? renderLine(hierarchyMetadata, treeDepthLevel)
        : null}
      <div className={contentClass}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            {codeItem.description ?
              <div className={`${styles.defaultColumn} d-block`}>
                {codeItem.description} <span className={styles.codeElement}>
                  #{codeItem.id}
                </span> <div className="d-inline-block">
                  {(refetching || deletingCodeItem) && <CodetableItemLoader />}
                </div>
              </div>
              : null}

            <span>
              {!!codeItem.childrenCount && isHierarchyMode &&
                <span className={styles.codeElement}>
                  <FaSitemap />&nbsp;{codeItem.childrenCount}
                </span>
              }
            </span>
          </div>
          <div className={styles.leftSideColumn}>
            <div className={styles.defaultColumn}>{hasSequence ? codeItem.sequence : null}</div>
          </div>
        </div>
        <div className={styles.rightSide}>
          <div className={styles.leftSideColumn}>
            {codeItem.icon ? <OptionIcon iconUrl={`${AppSetting.ApplicationUrl}${codeItem.icon}`} /> : null}

            {isDefinedIncludingZero(codeItem.colour) ? <OptionColor color={codeItem.colour} /> : null}

            {codeItem.category && codeItem.category.description
              ? <div className={`${styles.defaultColumn} d-block`}>
                {codeItem.category.description} <div className="d-inline-block">
                  {(refetching || deletingCodeItem) && <CodetableItemLoader />}
                </div>
              </div>
              : null}
          </div>
          <DisabledTag
            className={hasSequence ? styles.disabledTagSequence : styles.disabledTag}
            codeItem={codeItem}
            translation={translation} />
        </div>
      </div>
    </Link>
  );
};
